import { render, staticRenderFns } from "./StudentHomeworkStatis.vue?vue&type=template&id=48512925&scoped=true&"
import script from "./StudentHomeworkStatis.vue?vue&type=script&lang=js&"
export * from "./StudentHomeworkStatis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48512925",
  null
  
)

export default component.exports